{
  "unvan": {
    "Ünvanlar": "Title Definitions",
    "Unvan Adı": "Title Name",
    "Sıra": "Order",
    "Komisyon Türü": "Commission Type",
    "Durum": "Status",
    "Aktif": "Active",
    "Pasif": "Passive",
    "Tümü": "All",
    "Yeni Ekle": "Add New",
    "Ekle": "Add",
    "Güncelle": "Update",
    "Kaydet": "Save",
    "İptal": "Cancel",
    "Sil": "Delete",
    "Filtrele": "Filter",
    "Ara": "Search",
    "Temizle": "Clear",
    "Arama_Placeholder": "Search...",
    "Yenile": "Refresh",
    "İşlemler": "Actions",
    "Data Yenile": "Refresh Data",
    "Kapat": "Close",
    "Düzeltme": "Edit",
    "Ad_Placeholder": "Example: Manager, Specialist etc.",
    "Sira_Placeholder": "Example: 10"
  }
}
